import { render } from "./managePatientModal.vue?vue&type=template&id=2f847108&scoped=true"
import script from "./managePatientModal.js?vue&type=script&lang=js"
export * from "./managePatientModal.js?vue&type=script&lang=js"

import "./managePatientModal.vue?vue&type=style&index=0&id=2f847108&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f847108"]])

export default __exports__